module.exports = __webpack_public_path__ + "static/img/putcontent_2.6c84754.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ad/putcontent_2.png
// module id = yQgk
// module chunks = 1